import { useSnapshot } from "valtio";
import { state } from "../store";
import "./DeckColorsPanel.css";

export default function DeckColorsPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "deck-colors";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define deck-specific wood color presets
  const deckColors = [
    {
      name: "Teak Wood",
      color: "#c9a96e",
    },
    {
      name: "Mahogany",
      color: "#9c8355",
    },
    {
      name: "Oak Wood",
      color: "#916e57",
    },
    {
      name: "Cherry Wood",
      color: "#a0522d",
    },
    {
      name: "Teak Wood",
      color: "#916e57",
    },
    {
      name: "Cherry Wood",
      color: "#45331a",
    },
  ];

  const applyDeckColor = (colorPreset) => {
    // Store deck-specific color for PERU material ONLY
    state.deckColor = colorPreset.color;

    // Do NOT update waterColor - keep deck color independent
    // Do NOT close panel automatically - let user close manually
  };

  // Helper function to adjust brightness of a color
  const adjustBrightness = (hex, percent) => {
    const num = parseInt(hex.replace("#", ""), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const G = ((num >> 8) & 0x00ff) + amt;
    const B = (num & 0x0000ff) + amt;
    return "#" + (0x1000000 + (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 + (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 + (B < 255 ? (B < 1 ? 0 : B) : 255)).toString(16).slice(1);
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title">DECK COLORS</h2>
          <div className="deck-colors-wrapper">
            <div className="deck-colors-panel">
              <div className="deck-colors-grid">
                {deckColors.map((colorPreset, index) => (
                  <div key={index} className="deck-color-item" onClick={() => applyDeckColor(colorPreset)}>
                    <div
                      className="deck-color-swatch"
                      style={{
                        "--color": colorPreset.color,
                        "--color-light": adjustBrightness(colorPreset.color, 30),
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button className="close-button-deck-colors" onClick={handleClose}>
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
